"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Text_1 = require("./Text");

exports.Hero = function (props) {
  var children = props.children,
      className = props.className,
      size = props.size,
      color = props.color,
      fontWeight = props.fontWeight,
      as = props.as,
      italic = props.italic,
      rest = __rest(props, ["children", "className", "size", "color", "fontWeight", "as", "italic"]);

  return React.createElement(Text_1.Text, __assign({
    as: as,
    fontStyle: italic ? 'italic' : 'normal',
    fontWeight: fontWeight,
    color: "text." + color,
    fontSize: "desktop.hero." + size,
    lineHeight: "desktop.hero." + size,
    className: className
  }, rest), children);
};

exports.Hero.defaultProps = {
  as: 'p',
  size: 'sm',
  color: 'heading',
  italic: false,
  fontWeight: 'extrabold'
};